<template>
  <el-dialog
    :visible.sync="visible"
    width="60%"
    :before-close="handleClose"
    class="movements-dialog"
  >
    <div class="dialog-header">
      <i class="el-icon-document-checked header-icon"></i>
      <span class="header-title">Movimientos del certificado</span>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      :row-class-name="tableRowClassName"
      class="movements-table"
    >
      <el-table-column prop="date" label="Fecha" width="180" />
      <el-table-column prop="fase" label="Fase" />
      <template v-if="tableData.length === 0">
        <div class="empty-message">
          No hay movimientos para este certificado.
        </div>
      </template>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  name: "CertificationsMovements",
  props: {
    certificateId: {
      type: [String, Number],
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    }
    // ...existing code...
  },
  data() {
    return {
      tableData: []
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.fetchMovements();
      }
    },
    certificateId() {
      if (this.visible) {
        this.fetchMovements();
      }
    }
  },
  methods: {
    fetchMovements() {
      this.$http
        .get(
          `/api/certificationsdgii/GetStatusCertificate?certificateId=${this.certificateId}`
        )
        .then((res) => {
          const data = res.data || [];
          this.tableData = data.map((item) => ({
            date: this.formatDate(item.EventDate),
            fase: item.FaseId
          }));
        })
        .catch(() => {
          this.$message.error("Error al obtener movimientos");
        });
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    tableRowClassName({ row }) {
      if (row.fase === "warning") {
        return "warning-row";
      } else if (row.fase === "success") {
        return "success-row";
      }
      return "";
    },
    handleClose() {
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style scoped>
/* Decoración para el diálogo y tabla */
.movements-dialog >>> .el-dialog__body {
  background: #f8fafc;
  border-radius: 12px;
  padding: 24px 16px 16px 16px;
}
.dialog-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.header-icon {
  font-size: 28px;
  color: #409eff;
  margin-right: 10px;
}
.header-title {
  font-size: 20px;
  font-weight: 600;
  color: #222;
}
.movements-table {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.08);
  background: #fff;
}
.el-table .warning-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
.empty-message {
  text-align: center;
  color: #888;
  font-size: 16px;
  padding: 32px 0;
}
</style>
